import React, { useEffect, useState } from "react";
import { Button, Typography, Form, Select, Input, Tag, notification, Popconfirm } from "antd";
import { del, get } from "../../../api/axios";
import { Link } from "react-router-dom";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { checkPermission } from "../../control-sections/auth/ProtectedRoutes";
import { onChangeTableHelper } from "../../control-sections/helper/TableHelpers";
import TableComponent from "../../control-sections/helper/TableComponent";

const AgentTeamQuestions = () => {
    const { Title } = Typography;
    const [form] = Form.useForm();

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingSearch, setLoadingSearch] = useState(false);

    const [total, setTotal] = useState(1);

    const columns = [
        {
            title: " Id",
            dataIndex: "id",
            sorter: (a, b) => a.id - b.id,
        },
        {
            title: " question Ar",
            dataIndex: "question_ar",
            sorter: (a, b) => a.question_ar - b.question_ar,
        },
        {
            title: "question En",
            dataIndex: "question_en",
            sorter: (a, b) => a.question_en - b.question_en,
        },
        {
            title: " Answer Ar",
            dataIndex: "answer_ar",
            sorter: (a, b) => a.answer_ar - b.answer_ar,
            render: (answer_ar) => (
                <span dangerouslySetInnerHTML={{ __html: answer_ar }} />
            ),
        },
        {
            title: "Answer En",
            dataIndex: "answer_en",
            sorter: (a, b) => a.answer_en - b.answer_en,
            render: (answer_en) => (
                <span dangerouslySetInnerHTML={{ __html: answer_en }} />
            ),
        },
        {
            title: "Order",
            dataIndex: "order",
            sorter: (a, b) => a.order - b.order,
        },
        {
            title: "type",
            dataIndex: "type",
            render: (type) => (
                <>
                    <Tag color="blue">{type}</Tag>
                </>
            ),
            sorter: (a, b) => a.type - b.type,
        },
        {
            title: "Active",
            dataIndex: "is_active",
            render: (is_active) => (
                <>
                    <Tag color={`${is_active ? "success" : "error"}`}>
                        {String(Boolean(is_active))}
                    </Tag>
                </>
            ),
            sorter: (a, b) => a.is_active - b.is_active,
        },
    ];
    const handleDelete = (id) => {
        del(`agent-team-questions/${id}`)
        .catch((err) => {
            notification.error({
                message: "Error!",
                description: err.response.data.message
            });
            setLoading(false);
        });
        let dateFilter = data.filter((item) => item.id !== id);
        setData(dateFilter);
    };


    const confirm = (id) => {
        handleDelete(id);
        notification.success({message:"It was successful"});
    };

    const cancel = (e) => {
        notification.error("The order has been cancelled");
    };


    if (checkPermission("update-agent-team-question")||
    checkPermission("delete-agent-team-question")) {
        columns.push({
            title: "Actions",
            dataIndex: "id",
            render: (id) => (
                <div>
                    {checkPermission("update-agent-team-question") ? (
                        <Button className="btn btn-outline-warning btn-sm p-0 me-3">
                            <Link
                                className="color-inherit text-decoration-none py-1 px-2 d-block"
                                to={`/agent-team-questions/edit/${id}`}
                            >
                                <EditOutlined />
                            </Link>
                        </Button>
                    ) : (
                        <></>
                    )}
                    {checkPermission("delete-agent-team-question") ? (
                        <Popconfirm
                            title="Delete item"
                            description="Are you sure you want to delete this item?"
                            onConfirm={() => confirm(id)}
                            onCancel={cancel}
                            okText="OK"
                            cancelText="Cancel"
                        >
                            <Button danger className="flex-center d-inline-flex">
                                <DeleteOutlined />
                            </Button>
                        </Popconfirm>
                    ) : (
                        <></>
                    )}
                </div>
            ),
        });
    }

    useEffect(() => {
        get("agent-team-questions?page=1&limit=50&sort_by=order&order=asc").then((res) => {
            setData(res.data.data);

            setTotal(res.data.meta.total);
            setLoading(false);
        });
    }, []);


    const [filterData, setFilterData] = useState({
        filter_key: "",
        filter_value: "",
    });

    const [sorter, setSorter] = useState({
        sort_by: "",
        order: "",
    });

    const handleFilterKey = (e) => {
        setFilterData({ ...filterData, filter_key: e });
    };

    const handleFilterVal = (e) => {
        setFilterData({ ...filterData, [e.target.id]: e.target.value });
    };

    const onFilter = (values) => {
        setLoadingSearch(true);

        get(
            `agent-team-questions?filter_key=${filterData.filter_key}&filter_value=${filterData.filter_value
            }
            ${sorter.sort_by !== "" && sorter.sort_by !== undefined ? `&sort_by=${sorter.sort_by}` : ""}${sorter.order !== "" ? `&order=${sorter.order}` : ""
            }`
        )
            .then((res) => {
                setData(res.data.data);
                setTotal(res.data.meta.total);
                setLoadingSearch(false);
            })
            .catch((err) => {
                notification.error({
                    message: "Error!",
                    description: err.response.data.message,
                });
                setLoadingSearch(false);
            });
    };

    const clearSearch = () => {
        form.resetFields();
        setFilterData({
            filter_key: "",
            filter_value: "",
        });
        get("agent-team-questions?page=1&limit=50&sort_by=order&order=asc").then((res) => {
            setData(res.data.data);

            setTotal(res.data.meta.total);
        });
    };

    const onChangeTable = (pagination, filters, sorter) => {
        setLoading(true);

        setSorter({
            ...sorter,
            sort_by: sorter.field,
            order: sorter.order == "descend" ? "desc" : "asc",
        });

        onChangeTableHelper('agent-team-questions', pagination, filterData, sorter)
            .then((res) => {
                setData(res.data.data);

                setTotal(res.data.meta.total);
                setLoading(false);
            })
            .catch((err) => {
                notification.error({
                    message: "Error!",
                    description: err.response.data.message,
                });
                setLoading(false);
            });
    };

    return (
        <div>
            <div className="row">
                <div className="col-lg-12">
                    <div className="row">
                        <div className="col-6 col-lg-4">
                            <Title level={2} className="text-main mb-2">
                                {" "}
                                Team Questions{" "}
                            </Title>
                        </div>
                        {checkPermission("create-agent-team-question") ? (
                            <div className="col-6 col-lg-3 offset-lg-5 text-end">
                                <Button type="primary" className="p-0" size="large">
                                    <Link
                                        className="text-decoration-none h-100 flex-center py-2 px-4"
                                        to="/agent-team-questions/add"
                                    >
                                        {" "}
                                        Add Team Question{" "}
                                    </Link>
                                </Button>
                            </div>
                        ) : (
                            <></>
                        )}
                    </div>
                </div>
            </div>

            <div className="grid-margin stretch-card wrapper-content">
                <Form onFinish={onFilter} layout="vertical" form={form}>
                    <div className="row">
                        <div className="col-12 col-lg-4">
                            <Form.Item
                                label="Search By"
                                name="filter_key"
                                rules={[
                                    {
                                        required: true,
                                        message: "This field is required!",
                                    },
                                ]}
                            >
                                <Select
                                    className="w-100"
                                    showSearch
                                    placeholder="select test "
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.label ?? "")
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                    }
                                    onChange={handleFilterKey}
                                    options={[
                                        {
                                            value: "id",
                                            label: "Id",
                                        },
                                        {
                                            value: "question_ar",
                                            label: "Question Ar",
                                        },
                                        {
                                            value: "question_en",
                                            label: "Question En",
                                        },
                                    ]}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-12 col-lg-6">
                            <Form.Item
                                label="Search"
                                name="filter_value"
                                onChange={handleFilterVal}
                                rules={[
                                    {
                                        required: true,
                                        message: "This field is required!",
                                    },
                                ]}
                            >
                                <Input placeholder="Type to search..." />
                            </Form.Item>
                        </div>
                        <div className="col-12 col-lg-2 d-flex align-items-end">
                            <Form.Item className="w-100">
                                <div className="row">
                                    <div className="col-8">
                                        <Button
                                            block
                                            loading={loadingSearch}
                                            type="primary"
                                            htmlType="submit"
                                        >
                                            {loadingSearch ? "Searching" : "Search"}
                                        </Button>
                                    </div>
                                    <div className="col-4">
                                        <Button
                                            onClick={clearSearch}
                                            className="flex-center"
                                            danger
                                            type="primary"
                                        >
                                            <DeleteOutlined />
                                        </Button>
                                    </div>
                                </div>
                            </Form.Item>
                        </div>
                    </div>
                </Form>
                <TableComponent onChangeTable={onChangeTable} loading={loading} columns={columns} data={data} total={total} />
            </div>
        </div>
    );
};

export default AgentTeamQuestions;
